import React, { useEffect, useState } from "react";
import "./AllArticles.css";
import { getAllArticles } from './Api'; // Import the API function


const AllArticles = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    const fetchArticles = async () => {
      const allArticles = await getAllArticles();
      setArticles(allArticles);
    };
    fetchArticles();
  }, []);
  return (
    <section className="all-articles">
        <h2 className="all-articles-title">Articles</h2>
      <div className="article-flex">
        {articles.map((article) => (
          <a href={article.url} className="article-title"
          target="_blank" rel="noopener noreferrer">
          <div className="all-articles-line"key={article.id}>
            <h3 className="article-title">{article.title}</h3>
            <p className="article-date">{new Date(article.formatted_date).toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}</p>  {/* Use JavaScript to format the date */}
          </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default AllArticles;
